import React, {PureComponent} from 'react';
import './Order.css';
import QuestionForm from '../questionform/QuestionForm';
import arrowPointy from '../assets/arrow-pointy.svg';
import ReactDOM from "react-dom";


class Order extends PureComponent {

    lastElement;

    constructor() {
        super();
        this.actionClick = this.actionClick.bind(this);
        this.state = {
            bottomOpened: false
        };
    }

    actionClick(event) {
        let element = event.currentTarget;
        if (element.classList.contains("bottom-close-button") || element === this.lastElement) {
            event.stopPropagation();
            return;
        }

        this.lastElement = element;
        element.classList.add('open');
        element.focus();
        this.contactSign.classList.add('hidden');
        this.line.classList.add('hidden');
        if (!this.isMobile) {
            document.body.classList.add('no-scroll');
        }
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
    }

    closeAction(e) {
        if (!this.lastElement) {
            return;
        }

        e.stopPropagation();
        this.lastElement.classList.remove('open');
        this.lastElement.scrollTop = 0;
        this.lastElement = null;
        document.getElementById('order').focus();//To pull focus away
        this.contactSign.classList.remove('hidden');
        this.line.classList.remove('hidden');
        document.body.classList.remove('no-scroll');
    }

    isMobile = function () {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    componentDidMount() {
        document.getElementById('order').addEventListener('click', (e) => {
            if (!this.lastElement || this.lastElement.contains(e.target)) {
                return;
            }

            this.lastElement.classList.remove('open');
            this.lastElement.scrollTop = 0;
            this.lastElement = null;
            document.getElementById('order').focus();//To pull focus away
            this.contactSign.classList.remove('hidden');
            this.line.classList.remove('hidden');
            document.body.classList.remove('no-scroll');
        });

        this.contactModal = document.getElementById('contact-modal');
        window.addEventListener('click', (event) => {
            if (event.target === this.contactModal) {
                this.contactModal.style.display = 'none';
                document.body.classList.remove('no-scroll');
            }
        });

        window.addEventListener('keydown', (evt) => {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                this.contactModal.style.display = 'none';
                document.body.classList.remove('no-scroll');
            }
        });
    }

    openContactModal() {
        this.contactModal.style.display = 'block';
        document.body.classList.add('no-scroll');
    }

    render() {
        return (
            <div id="order-block">
                <div className="general-contact">
                    <h2 className="contact-button" onClick={() => this.openContactModal()}>
                        Soovid meilt midagi küsida?
                        <img className="arrow ask-arrow" src={arrowPointy}/>
                    </h2>
                    <div id="contact-modal" className="contact-modal">
                        <QuestionForm/>
                    </div>
                </div>

                <div className="select">
                    <span className="contactSign" ref={(contactSign) => {
                        this.contactSign = contactSign;
                    }}>
                        kontakt</span>
                    <span className="contact-line" ref={(line) => {
                        this.line = line;
                    }}/>
                    <div id="hire-us" className="action"
                         onClick={(e) => this.actionClick(e)}
                         ref={(hireUs) => this.hireUs = hireUs}>
                        <div className="bottom-close-button" onClick={(e) => this.closeAction(e)}>
                            <span className="bottom-close-line bottom-line1"/>
                            <span className="bottom-close-line bottom-line2"/>
                        </div>
                        <h4 class="action-subtitle">
                            planeeri projekti
                        </h4>
                        <h1 className="action-title">
                            Teeme koostööd
                        </h1>
                        <div id="text">
                            <div className="text-block top-text">
                                <h3 className="text-header">
                                    Videoklippide tootmine
                                </h3>
                                <p className="text-content">
                                    Pakume enda teenustena reklaamklippide, muusikavideote tootmist ja
                                    ürituse, loengute ning konverentside salvestust.
                                    Parima tulemuse saavutamiseks kasutab filmiklubi stabilisaatoril
                                    liikuvaid kaameraid ning teostab ka droonvõtteid.
                                </p>
                            </div>
                            <div className="text-block bottom-text">
                                <h3 className="text-header">
                                    Veebiülekanded
                                </h3>
                                <p className="text-content">
                                    TalTech Filmiklubi suudab pakkuda kuni kuue kaameraga (või sisendiga)
                                    kuni FullHD kvaliteediga teostatud veebiülekandeid või live-režiiga salvestusi,
                                    millele saab lisada ka graafikat, eelsalvestatud videomaterjali jpm.
                                </p>
                                <p className="text-header text-email">
                                    Saada kiri info@filmiklubi.ee ja viime Sinu projekti ellu!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="join-us" className="action"
                         onClick={(e) => this.actionClick(e)}
                         ref={(joinUs) => this.joinUs = joinUs}>
                        <div className="bottom-close-button" onClick={(e) => this.closeAction(e)}>
                            <span className="bottom-close-line bottom-line1"/>
                            <span className="bottom-close-line bottom-line2"/>
                        </div>
                        <h4 class="action-subtitle">
                            tule tutvuma
                        </h4>
                        <h1 className="action-title">
                            Liitu meiega
                        </h1>
                        <div id="text">
                            <div className="text-block top-text">
                                <h3 className="text-header">
                                    TalTech Filmiklubiga liitumine
                                </h3>
                                <p className="text-content">
                                    TalTech Filmiklubi liikmetel on võimalus õppida iseseisvalt videoproduktsiooni.
                                    Ootame enda liikmeteks huvilisi, kellel on soov iseseivalt õppida võttekoha
                                    ülesseadmist, operaatoritööd, videomontaaži, režiid, saate toimetamist,
                                    reporteritööd, mitmekaameraga live-ülekandeid, lühifilmide teostamist jpm.
                                </p>
                            </div>
                            <div className="text-block bottom-text">
                                <h3 className="text-header">
                                    Keda otsime
                                </h3>
                                <p className="text-content">
                                    Loomulikult ei koosne filmiklubi meeskond vaid videoga seotud inimestest.
                                    Otsime enda ridadesse turundusest, ürituste korraldamisest ja tehnikast huvitatud
                                    tudengeid. Filmiklubi on hea platvorm õppimaks MTÜ juhtimist, ülesehitamist ja
                                    arendamist. Kui tunned, et tahaksid olla osa organisatsioonist, milles on sul
                                    kõigis eelmainitutes ja paljudes muudes alades võimalik kätt proovida, liitu
                                    Filmiklubiga!
                                </p>
                                <div id="fill-form">
                                    <a className="form text-header" href="https://forms.gle/ovtBdcgHJtrhq6B46">
                                        Liitumiseks täida blankett
                                    </a>
                                    <img className="arrow" src={arrowPointy}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span id="contact-sign-container"/>
                </div>
            </div>
        );
    }
}

export default Order;



// WEBPACK FOOTER //
// ./src/order/Order.js